import { render } from "./InputRole.vue?vue&type=template&id=39cfc780"
import script from "./InputRole.vue?vue&type=script&lang=js"
export * from "./InputRole.vue?vue&type=script&lang=js"
script.render = render

export default script